import { render, staticRenderFns } from "./Audiencia.vue?vue&type=template&id=66a7d480"
import script from "./Audiencia.vue?vue&type=script&lang=js"
export * from "./Audiencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports